import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectSelectedUsers = createSelector(
  [(store: RootState) => store.massiveDocumentCreate.selectedUsers],
  (step) => step
);
